/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { object, string } from 'prop-types';
import { gql } from '@apollo/client';
import { Query } from '@apollo/client/react/components';
import mbpLogger from 'mbp-logger';
import { compose } from 'recompose';
import { GRAPHQL_ENV } from '../../../gql';
import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';
import RecipeCategoryLanderPage from './RecipeCategoryLanderPage';

// import Graphql404ErrorContainer from '../Graphql404Error/Graphql404ErrorContainer';

const GraphqlRecipeCategoryLanderPage = ({ page, brand, currRecipePath }) => {
    const currRecipeName = currRecipePath.includes('/h/recipes/') ? currRecipePath.split('/h/recipes/')[1] : currRecipePath;

    let recipeName = '';
    if (currRecipeName) {
        recipeName = currRecipeName.charAt(0).toUpperCase() + currRecipeName.slice(1);
    }

    const RECIPE_CATEGORY_QUERY = gql`{
        lander: findContent(brand: "${brand.domain}", environment: "${GRAPHQL_ENV}", contentType: "recipe_category_lander", query:"{\\"title\\" : \\"${recipeName}\\"}")
        {content}
        findContent(brand: "${brand.domain}", environment: "${GRAPHQL_ENV}", contentType: "recipe_entry", query:"{\\"recipe_category\\" : \\"${recipeName}\\"}")
        {content}
    }`;
    return (
        <Query query={RECIPE_CATEGORY_QUERY}>
            {({ loading, error, data }) => {
                if (loading) return null; // skeleton component

                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: RECIPE_CATEGORY_QUERY,
                        component: 'GraphqlRecipeCategoryLanderPage.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: RECIPE_CATEGORY_QUERY,
                        component: 'GraphqlRecipeCategoryLanderPage.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                const recipes = data.findContent.content.entries;
                const seo = data.lander?.content?.entries?.length ? data.lander.content.entries[0]?.seo : {};

                return (
                    <>
                        {recipeName && <RecipeCategoryLanderPage page={page} recipes={recipes} recipeName={recipeName} seo={seo} brand={brand.domain} />}
                    </>
                );
            }}
        </Query>
    );
};

GraphqlRecipeCategoryLanderPage.propTypes = {
    page: object.isRequired,
    brand: object.isRequired,
    currRecipePath: string.isRequired,
};

const enhance = compose(
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
);

export default enhance(GraphqlRecipeCategoryLanderPage);
